/*
 * Sonatype Nexus (TM) Open Source Version
 * Copyright (c) 2008-present Sonatype, Inc.
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/oss/attributions.
 *
 * This program and the accompanying materials are made available under the terms of the Eclipse Public License Version 1.0,
 * which accompanies this distribution and is available at http://www.eclipse.org/legal/epl-v10.html.
 *
 * Sonatype Nexus (TM) Open Source Version is distributed with Sencha Ext JS pursuant to a FLOSS Exception agreed upon
 * between Sonatype, Inc. and Sencha Inc. Sencha Ext JS is licensed under GPL v3 and cannot be redistributed as part of a
 * closed source work.
 *
 * Sonatype Nexus (TM) Professional Version is available from Sonatype, Inc. "Sonatype" and "Sonatype Nexus" are trademarks
 * of Sonatype, Inc. Apache Maven is a trademark of the Apache Software Foundation. M2eclipse is a trademark of the
 * Eclipse Foundation. All other trademarks are the property of their respective owners.
 */
import { ROUTE_NAMES } from '../routeNames/routeNames';
import { ExtJS } from '@sonatype/nexus-ui-plugin';
import CoreUILoginPageWrapper from '../../components/login/CoreUILoginPageWrapper';

const LOGIN = ROUTE_NAMES.LOGIN;

/**
 * Login routes configuration.
 * Routes are only registered if the React login feature flag is enabled.
 */
export function getLoginRoutes() {
  // Check if ExtJS is available (not available in test environment)
  if (!ExtJS?.state) {
    return [];
  }
  
  const isReactLoginEnabled = ExtJS.state().getValue('nexus.login.react.enabled', false);
  
  if (!isReactLoginEnabled) {
    return [];
  }

  return [
    {
      name: LOGIN,
      url: 'login',
      component: CoreUILoginPageWrapper,
      data: {
        visibilityRequirements: {}
      }
    }
  ];
}
